// extracted by mini-css-extract-plugin
export default {"wrapper":"Z0-z","play":"_0-z"};